import React from 'react'
import Button from './Button'

const ButtonIconEdit = (props) => {
  return (
    <Button
      icon="edit"
      {...props}
    />
  )
}

export default ButtonIconEdit
